import moment from 'moment';

/*
* The request view mode
* */
const RequestTimeFrame = Object.freeze({
    Day:   'day',
    Week: 'week',
    Month: 'month',
    Year:  'year',
    Hour: 'hour'
});

export default class ChartHelper {

    static FindMaxPeak(values){

        function computePeak(chartData, peakProperty = "peak") {
            let max = 0;
            for(let i = 0 ;  i < chartData.length; i++){
                if(chartData[i][peakProperty] >  max){
                    max = chartData[i][peakProperty];
                }
            }

            return max;
        }

        let maxPeak  = computePeak(values[0]);
        for(let i = 1;  i < values.length ; i++){
            let peak = computePeak(values[i]);
            if(peak > maxPeak){
                maxPeak = peak;
            }
        }

        return maxPeak;
    }


    static GenerateLabels(timeFrame, charData){

        let labels = [];

        //  build labels
        for(let i = 0 ; i < charData.length; i++ ){

            let request = charData[i];
            let time = moment(request.time);

            switch (timeFrame){
                case RequestTimeFrame.Hour:
                    labels.push(time.format("HH"));
                    break;
                case RequestTimeFrame.Week:
                    labels.push(time.format('Wo [week]'));
                    break;
                case RequestTimeFrame.Day:
                    labels.push(time.format('MMM Do'));
                    break;
                case RequestTimeFrame.Month:
                    labels.push( time.format('MMM YYYY') );
                    break;
                case RequestTimeFrame.Year:
                    labels.push( time.year() );
                    break;
            }
        }

        return labels;

    }

}


// WEBPACK FOOTER //
// ./src/common/ChartHelper.js